import React from "react";

// Shared loading state for every TrustCall card — a single spinning circle so
// all cards look consistent (matches the Account Verizon Call Volume widget).
const CardLoading: React.FC = () => (
  <div className="text-center py-3">
    <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> Loading...
  </div>
);

export default CardLoading;
